<template>
  <div class="gray-back" style="height: 100%">
    <div v-if="isWeixin">
      <div class="shareShow">
        <div>
          <h2>请点击右上角，选择浏览器打开并下载文件</h2>
        </div>
      </div>
    </div>
<!--    <iframe v-else :src="url" frameborder="0"></iframe>-->
  </div>
</template>
<style scoped>
iframe {
  width: 100%;
  height: 100vh;
}
</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'FileDownload',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      url: '',
      isWeixin:window.isWeixin()
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "文件下载"
    let url = this.$route.query.url;
    if(!window.isWeixin()) {
      // 普通浏览器
      window.location.href= url
      // this.url = url;
    } else {
      // 微信浏览器
    }
    console.log(url)

    // that.fetch();

  },
  watch: {},
  destroyed() {
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// FileDownload.vue?794ba2c6